import { LoginRadiusAdapter } from '..'
import { logger } from '../../../../../utils/common/logger'
import { DOMUtils } from '../../../../../utils/dom'
import { Store } from '../../../../../utils/storage/keys'
import { IdentityEvent } from '../../../../common/events/identity'
import { IdentityScreen } from '../../../enums'
import { PasswordRequirementsList } from '../../../modules/password-requirements-list'
import { LoginService } from '../services/login-service'
import { LoginRadiusWidget, LRWidgetType } from './base'

export interface IWindow extends Window {
    tp: any
}

declare let window: IWindow

export class RegistrationWidget extends LoginRadiusWidget {
    private static DOM = {
        class: {
            passwordContainer: 'content-loginradius-password'
        }
    }
    constructor(container: string, lrObject: any) {
        super()
        this.widgetType = LRWidgetType.REGISTRATION
        this.lrObject = lrObject
        this.container = container
        const resendEmailButton = document.querySelector('.identity__link[type=button]') as HTMLButtonElement
        if (resendEmailButton) {
            resendEmailButton.addEventListener('click', () => {this.resendRegistrationEmail()})
        }
    }

    /**
     * Callback function used by LR widget
     * @param response any
     *
     * reference: https://www.loginradius.com/docs/libraries/js-libraries/js-form-library/
     */
    public onSuccess(response: any) {
        logger('debug', 'Registration form success', response)
        LoginService.clearErrors()
        const jwtToken = response.jwttoken
        // store token
        localStorage.setItem(Store.JWT, jwtToken)

        // Setting the new JWT token for authenticated user
        window.tp.push(['setExternalJWT', jwtToken])

        const profileData = LoginService.createProfile(response.Profile)
        const emailAddressEl = document.querySelector('[data-identity-email]')

        document.dispatchEvent(new CustomEvent(IdentityEvent.NEW_REGISTRATION, {
            detail: {
                email: profileData.email,
                uuid: profileData.uuid
            }
        }))

        LoginService.sendRegistrationAnalytics(response.Profile.RegistrationProvider || 'traditionalRegister')
        // Get stored redirect URL
        const redirectUrl = sessionStorage ? sessionStorage.getItem(Store.REDIRECT_URL) : location.origin
        const userWants = sessionStorage ? sessionStorage.getItem(Store.USER_WANTS) : 'register'

        // Skip registration success screen if session storage key found
        if (sessionStorage && sessionStorage.getItem(Store.ACTIVATE_BUTTON)) {
            sessionStorage.removeItem(Store.ACTIVATE_BUTTON)

            // remove item from session storage
            sessionStorage.removeItem(Store.REDIRECT_URL)

            // tslint:disable-next-line: max-line-length
            location.replace(`${LoginRadiusAdapter.ssoRedirectLink}&token=${response.access_token}&callback=${redirectUrl}`)
            return
        }
        // if anonymous user wants to subscribe - skip registration confirmation / success page
        if (redirectUrl && userWants === 'subscribe') {
            // remove item from session storage
            sessionStorage.removeItem(Store.USER_WANTS)
            location.replace(
                `${LoginRadiusAdapter.ssoRedirectLink}&token=${response.access_token}&callback=${redirectUrl}`)
            return
        }
        // Success page
        DOMUtils.removeClass(document.body, IdentityScreen.FORM)
        DOMUtils.addClass(document.body, IdentityScreen.SUCCESS)

        // add email address
        if (emailAddressEl) {
            emailAddressEl.innerHTML = profileData.email
        }

        LoginService.setRedirectLink(response.access_token)
        LoginService.setSSOFooterLinks(response.access_token)
    }

    /**
     * Callback function used by LR widget
     * @param errors any
     *
     * reference: https://www.loginradius.com/docs/libraries/js-libraries/js-form-library/
     */
    public onError(errors: any) {
        logger('error', errors)
        LoginService.clearErrors()
        LoginService.showErrors(errors)
        PasswordRequirementsList.showPasswordRequirementsList(RegistrationWidget.DOM.class.passwordContainer)
        LoginService.sendSubmissionErrorAnalytics(errors, 'registration')
    }

    /**
     * Resend email as per user request
     */
    public resendRegistrationEmail() {
        logger('info', 'Email resend requested')
        const registrantEmail = document.querySelector('[data-identity-email]')
        this.lrObject.api.resendEmailVerification({
                email: registrantEmail.innerHTML
            },
            this.onResendEmailSuccess,
            this.onResendEmailError
        )
    }

    /**
     * Callback function used by Resend email function
     * @param response any
     *
     * reference:
     * https://www.loginradius.com/docs/developer/references/javascript-library/form-library/#resend-email-verification
     */
    public onResendEmailSuccess(response: any) {
        logger('info', response)

        // Disable resent email button
        const resendEmailButton = document.querySelector('.identity__link[type=button]') as HTMLButtonElement
        resendEmailButton.setAttribute('disabled', 'disabled')

        // Show success message
        const successMessage = document.createElement('p')
        successMessage.innerHTML = 'We have resent your activation email'
        DOMUtils.addClass(successMessage, 'resend-activation-email__message--success')

        if (resendEmailButton) {
            resendEmailButton.parentElement.after(successMessage)
        }
    }

    /**
     * Callback function used by Resend email function
     * @param errors any
     *
     * reference:
     * https://www.loginradius.com/docs/developer/references/javascript-library/form-library/#resend-email-verification
     */
    public onResendEmailError(errors: any) {
        logger('error', errors)
    }
}
